import Bootstrap from './common/bootstrap.js'
Bootstrap.run()



// WEBPACK FOOTER //
// ./src/main.js